import React, { useState } from 'react';
import Icon from 'components/AppIcon';
import { ROLE_CONFIG, ROLE_DESCRIPTIONS, ACTIVE_DEALS } from './teamData';

export default function InviteMemberModal({ onClose, showToast }) {
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [role, setRole] = useState('Investor');
  const [organisation, setOrganisation] = useState('');
  const [selectedDeals, setSelectedDeals] = useState([]);
  const [message, setMessage] = useState('');
  const [emailError, setEmailError] = useState('');

  const validateEmail = (val) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/?.test(val);

  const toggleDeal = (deal) => setSelectedDeals(prev => prev?.includes(deal) ? prev?.filter(d => d !== deal) : [...prev, deal]);

  const handleSend = () => {
    if (!validateEmail(email)) { setEmailError('Please enter a valid email address.'); return; }
    setEmailError('');
    showToast(`Invitation sent to ${email}`);
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4" onClick={onClose}>
      <div className="bg-card rounded-2xl shadow-2xl w-full max-w-lg max-h-[90vh] overflow-y-auto" onClick={e => e?.stopPropagation()}>
        <div className="flex items-center justify-between p-6 border-b border-border">
          <div>
            <h3 className="font-heading text-lg font-bold text-foreground">Invite Member</h3>
            <p className="font-caption text-sm text-muted-foreground mt-0.5">Send an invitation to join the platform</p>
          </div>
          <button onClick={onClose} className="p-2 rounded-lg hover:bg-muted"><Icon name="X" size={18} /></button>
        </div>
        <div className="p-6 space-y-4">
          <div>
            <label className="block font-caption text-sm font-medium text-foreground mb-1">Email Address <span className="text-red-500">*</span></label>
            <input
              type="email"
              value={email}
              onChange={e => { setEmail(e?.target?.value); setEmailError(''); }}
              placeholder="colleague@organisation.com"
              className={`w-full border rounded-lg px-3 py-2 font-caption text-sm focus:outline-none focus:ring-2 focus:ring-primary/20 bg-card text-foreground ${emailError ? 'border-red-400' : 'border-border'}`}
            />
            {emailError && <p className="font-caption text-xs text-red-500 mt-1">{emailError}</p>}
          </div>
          <div>
            <label className="block font-caption text-sm font-medium text-foreground mb-1">Full Name <span className="text-muted-foreground">(optional)</span></label>
            <input
              type="text"
              value={name}
              onChange={e => setName(e?.target?.value)}
              placeholder="Jane Smith"
              className="w-full border border-border rounded-lg px-3 py-2 font-caption text-sm focus:outline-none focus:ring-2 focus:ring-primary/20 bg-card text-foreground"
            />
          </div>
          <div>
            <label className="block font-caption text-sm font-medium text-foreground mb-1">Role <span className="text-red-500">*</span></label>
            <select
              value={role}
              onChange={e => setRole(e?.target?.value)}
              className="w-full border border-border rounded-lg px-3 py-2 font-caption text-sm focus:outline-none focus:ring-2 focus:ring-primary/20 bg-card text-foreground"
            >
              {Object.keys(ROLE_CONFIG)?.map(r => <option key={r} value={r}>{r}</option>)}
            </select>
            <p className="font-caption text-xs text-muted-foreground mt-1">{ROLE_DESCRIPTIONS?.[role]}</p>
          </div>
          <div>
            <label className="block font-caption text-sm font-medium text-foreground mb-1">Organisation</label>
            <input
              type="text"
              value={organisation}
              onChange={e => setOrganisation(e?.target?.value)}
              placeholder="Organisation name"
              className="w-full border border-border rounded-lg px-3 py-2 font-caption text-sm focus:outline-none focus:ring-2 focus:ring-primary/20 bg-card text-foreground"
            />
          </div>
          <div>
            <label className="block font-caption text-sm font-medium text-foreground mb-2">Deal Access <span className="text-muted-foreground">(optional — leave blank for role-default access)</span></label>
            <div className="border border-border rounded-xl p-3 max-h-36 overflow-y-auto space-y-1.5">
              {ACTIVE_DEALS?.map(deal => (
                <label key={deal} className="flex items-center gap-2 cursor-pointer hover:bg-muted rounded-lg px-2 py-1">
                  <input
                    type="checkbox"
                    checked={selectedDeals?.includes(deal)}
                    onChange={() => toggleDeal(deal)}
                    className="rounded border-border text-primary focus:ring-primary/20"
                  />
                  <span className="font-caption text-sm text-foreground">{deal}</span>
                </label>
              ))}
            </div>
          </div>
          <div>
            <label className="block font-caption text-sm font-medium text-foreground mb-1">Personal Message <span className="text-muted-foreground">(optional)</span></label>
            <textarea
              value={message}
              onChange={e => setMessage(e?.target?.value)}
              rows={3}
              placeholder="Add a personal note to the invitation email…"
              className="w-full border border-border rounded-lg px-3 py-2 font-caption text-sm resize-none focus:outline-none focus:ring-2 focus:ring-primary/20 bg-card text-foreground"
            />
          </div>
        </div>
        <div className="flex gap-3 p-6 border-t border-border">
          <button onClick={onClose} className="flex-1 px-4 py-2 border border-border rounded-lg font-caption text-sm font-medium text-muted-foreground hover:bg-muted">Cancel</button>
          <button
            onClick={handleSend}
            className="flex-1 flex items-center justify-center gap-2 px-4 py-2 rounded-lg font-caption text-sm font-semibold text-white bg-primary hover:bg-primary/90 transition-colors"
          >
            <Icon name="Send" size={14} />
            Send Invite
          </button>
        </div>
      </div>
    </div>
  );
}
